<template>
  <div class="modal_wrap chat_write_form_modal" :class="{ on: isOpen }">
    <!--'on 추가'-->
    <div class="modal_inner">
      <div class="modal">
        <div class="modal_head">
          {{ title }}
        </div>
        <div class="modal_con">
          <p v-if="type === 'Review'">
            매장 평가하기 버튼을 숨긴 후에는 <br />
            매장 상세보기에서 다시 작성하실 수 있습니다.
          </p>
          <p v-else>
            {{ type === 'Internet' ? '인터넷 가입신청서' : '휴대폰 방문약속' }}
            버튼을 숨긴 후에는 <br />
            하단의 ‘+’ 버튼에서 다시 볼 수 있습니다.
          </p>
        </div>
        <div class="modal_btn">
          <div class="btn_wrap">
            <button class="btn bo grey" @click="close(false)">
              닫기
            </button>
            <button class="btn" @click="close(true)">
              숨기기
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatOptionModal',
  data() {
    return {
      isOpen: false,
      type: '',
      title: '',
    };
  },
  methods: {
    close(dataType) {
      this.$emit('close', dataType, this.type);
    },
  },
};
</script>
